import type { createToaster } from '@chakra-ui/react';
import { toasterOriginal, toaster, toasterCopy, notification } from '../components/Toaster';
import { copyToClipboard, copyFileToClipboard } from './copy';
import { getShareUrlEllipsis } from './getShareUrlEllipsis';
import { defaultExpireTimeValue, expireTimeOptions } from './expireTimeOptions';

export const tools = {
  getShareUrlEllipsis,
  copyToClipboard,
  copyFileToClipboard,
  expireTimeOptions,
  defaultExpireTimeValue,
  toasterOriginal: toasterOriginal as ReturnType<typeof createToaster>,
  notification: notification as ReturnType<typeof createToaster>,
  toaster: toaster as ReturnType<typeof createToaster>,
  toasterCopy: toasterCopy as ReturnType<typeof createToaster>,
};
